// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/pages/Home.vue'
import Pricing from '@/pages/Pricing.vue'
import Account from '@/pages/Account.vue'
import Calculator from '@/pages/Calculator.vue' // keep if you still need legacy page
const Contact = () => import('@/pages/Contact.vue')
const ContactThanks = () => import('@/pages/ContactThanks.vue')
const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', component: Home },

    // Primary tool (formerly /route)
    {
      path: '/route',
      name: 'RobotCycleCalculator',
      component: () => import('@/pages/RouteCalculator.vue'),
      meta: { title: 'Robot Cycle Calculator' }
    },
    { path: '/robot-cycle-calculator', redirect: '/route' }, // friendly URL
    { path: '/planner', redirect: '/route' },                 // old alias

    { path: '/pricing', component: Pricing },
    { path: '/account', component: Account },

    { path: '/how-to', name: 'how-to', component: () => import('@/pages/HowTo.vue') },

    // (optional) legacy calculator page
    { path: '/calculator', component: Calculator },

    // Fallback MUST be last
    { path: '/:pathMatch(.*)*', redirect: '/' },
    { path: '/disclaimer', component: () => import('@/pages/Disclaimer.vue') },
    { path: '/terms', component: () => import('@/pages/Terms.vue') },
    { path: '/privacy', component: () => import('@/pages/Privacy.vue') },
    { path: '/contact', name: 'contact', component: Contact },
{ path: '/contact/thanks', name: 'contact-thanks', component: ContactThanks },
  ],
  scrollBehavior: () => ({ top: 0 })
})

// Optional: dynamic page titles
router.afterEach((to) => {
  document.title = to.meta?.title
    ? `${to.meta.title} – Robot Cycle Time AI`
    : 'Robot Cycle Time AI'
})

export default router
